var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.249 13.91C14.463 15.503 13.398 17.09 12.309 18.515C11.2759 19.8584 10.1713 21.1453 9 22.37C7.82862 21.1453 6.72403 19.8584 5.691 18.515C4.602 17.09 3.537 15.503 2.751 13.91C1.956 12.3005 1.5 10.793 1.5 9.5C1.5 7.51088 2.29018 5.60322 3.6967 4.1967C5.10322 2.79018 7.01088 2 9 2C10.9891 2 12.8968 2.79018 14.3033 4.1967C15.7098 5.60322 16.5 7.51088 16.5 9.5C16.5 10.793 16.0425 12.3005 15.249 13.91ZM9 24.5C9 24.5 18 15.971 18 9.5C18 7.11305 17.0518 4.82387 15.364 3.13604C13.6761 1.44821 11.3869 0.5 9 0.5C6.61305 0.5 4.32387 1.44821 2.63604 3.13604C0.948211 4.82387 3.55683e-08 7.11305 0 9.5C0 15.971 9 24.5 9 24.5Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5C8.20435 12.5 7.44129 12.1839 6.87868 11.6213C6.31607 11.0587 6 10.2956 6 9.5C6 8.70435 6.31607 7.94129 6.87868 7.37868C7.44129 6.81607 8.20435 6.5 9 6.5C9.79565 6.5 10.5587 6.81607 11.1213 7.37868C11.6839 7.94129 12 8.70435 12 9.5C12 10.2956 11.6839 11.0587 11.1213 11.6213C10.5587 12.1839 9.79565 12.5 9 12.5ZM9 14C10.1935 14 11.3381 13.5259 12.182 12.682C13.0259 11.8381 13.5 10.6935 13.5 9.5C13.5 8.30653 13.0259 7.16193 12.182 6.31802C11.3381 5.47411 10.1935 5 9 5C7.80653 5 6.66193 5.47411 5.81802 6.31802C4.97411 7.16193 4.5 8.30653 4.5 9.5C4.5 10.6935 4.97411 11.8381 5.81802 12.682C6.66193 13.5259 7.80653 14 9 14Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4b49683fd856b9c8e3831ea6b508878b.svg";
export { ForwardRef as ReactComponent };